import React from 'react';
import {StickersCanvas} from '~/common/FabricInvitation/EventCreateDesign/components/Sticker/StickersCanvas';

export const StickersCanvasWrapper: React.FC = () => (
  <StickersCanvas className="envelope_image__wrapper__canvas" />
);
